import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ParametroCarga } from '../../models/spinner/parametroCarga.class';

@Injectable()
export class SpinnerService {

  public status: BehaviorSubject<ParametroCarga> = new BehaviorSubject<ParametroCarga>(new ParametroCarga('', false));

  constructor() { }

  display(value: ParametroCarga) {
    this.status.next(value);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/spinner/spinner.service.ts